import { gql } from '@apollo/client';

export const ContinuityEscrowBaseFields = gql`
  fragment ContinuityEscrowBaseFields on ContinuityEscrow {
    id
    changesRequested
    agreement {
      id
      agreementForm
      approved
    }
    escrowInvitation {
      id
      status
      partyType
      companyName
      escrow {
        id
      }
      policy {
        accept
      }
    }
    escrowTermination {
      status
      terminateAt
    }
    status
    beneficiary {
      id
      companyName
      companyWebsite
    }
    depositor {
      id
      companyName
      companyWebsite
    }
    policy {
      remove
    }
    createdAt
    adminReviewAt
    onboardingAt
    signedAt
    activatedAt
    certificationVerified
    certificationCertified
    userUpdatedAt
    pendingActivation
    hostingProviders {
      id
      status
    }
    thirdPartyProviders {
      id
      status
    }
    lastProvider
  }
`;

export const ContinuityEscrowPolicyFields = gql`
  fragment ContinuityEscrowPolicyFields on ContinuityEscrowPolicy {
    activate
    createAgreementSuggestedChange
    createBeneficiary
    createBeneficiarySuggestedChange
    createDepositorSuggestedChange
    createEnvironmentSuggestedChange
    createNotificationSuggestedChange
    createProviders
    deferActivation
    enableReports
    inviteBeneficiary
    inviteDepositor
    read
    remove
    requestTermination
    update
    updateBeneficiaryNotifications
    updateDepositorNotifications
    write
  }
`;
